<template>
  <div class="more-products-container">
    <h3>More Tools & Products
      <a href="http://twitter.com/ahmetsulek" target="_blank" @click="$ga.event('more-products', 'twitter');">by @ahmetsulek</a>
    </h3>

    <Product v-for="product in products" @click.native="$ga.event('more-products', product.id)" :key="product.id" :product=product />
  </div>
</template>

<script>
import Product from "@/components/Product";

let products = require("@/data/products.json");

export default {
  name: "MoreProducts",
  components: {
    Product
  },
  data() {
    return {
      products
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
  @import "~@/styles/common.scss";
.more-products-container {
  display: block;
  width: 1024px;
  float: left;
  margin-top: 50px;
  h3 {
    font-size: 24px;
    text-transform: uppercase;
    letter-spacing: 2px;
    a {
      text-transform: lowercase;
      color: #fff;
      font-size: 18px;
      float: right;
      font-weight: normal;
      position: relative;
      top: 6px;
      letter-spacing: 1px;
      display: block;
      &:hover{
        animation-name: action-tada;
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
        animation-duration: 0.6s;
      }
    }
  }
}


@keyframes action-tada {
  0% {
    transform: scaleY(1);
  }
  15% {
    transform: scaleY(0.95);
  }
  30% {
    transform: scaleY(0.9);
  }
  55% {
    transform: scaleY(0.75);
  }
  70% {
    transform: scaleY(1.3);
  }
  85% {
    transform: scaleY(0.95);
  }
  100% {
    transform: scaleY(1);
  }
}

@media (max-width: 600px) {
  .more-products-container {
    width: 100%;
    h3{
      line-height: 32px;
      a{
        float: left;
        clear: both;
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MoreProducts.vue